// extracted by mini-css-extract-plugin
module.exports = {"footerDesktop":"Footer__footerDesktop___1UCTr","footerMobile":"Footer__footerMobile___1iEPe"};